import styled from "styled-components";

const WorkText = styled.div`
  margin-bottom: 1em;
  margin-top: 1em;

  p {
    text-align: justify;
  }
`;

export default WorkText;
